import { useSelector } from "react-redux";
import { AppStore } from 'types';

export const useApp = (): AppStore => useSelector(state => state.app);